import { Table } from "@spz/ui/components/table";
import { DataTableBody } from "@spz/ui/components/table/data-table-body";
import { DataTableHeader } from "@spz/ui/components/table/data-table-header";
import { DataTablePagination } from "@spz/ui/components/table/data-table-pagination";
import { Typography } from "@spz/ui/components/typography";
import { useTranslation } from "react-i18next";
import { selectControlResultDetailsViewModel } from "../view-models/select-control-result-details.view-model";
import ResultDetailActivityTabs from "./details-sheet/result-details-activity-tabs";
import ResultValues from "./details-sheet/result-values";

interface IControlResultDetailsProps {
  controlId: string;
  controlResultId: string;
  companyId: string;
  onLoadError: () => void;
}

export const ControlResultDetails = ({
  controlId,
  controlResultId,
  companyId,
  onLoadError,
}: IControlResultDetailsProps) => {
  const { t } = useTranslation();

  const { table, resultValues, isLoading } =
    selectControlResultDetailsViewModel({
      controlId,
      controlResultId,
      onLoadError,
    });

  return (
    <div className="flex flex-col gap-4">
      {/* Information Panel */}
      <section
        className="bg-white rounded-md p-4 flex flex-wrap justify-between"
        aria-label="Information Panel"
      >
        <ResultValues
          isLoading={resultValues?.isLoading}
          data={resultValues.data}
        />
      </section>

      {/* Details Title */}
      <Typography variant="h5">{t("details")}</Typography>

      <div className="flex gap-4 items-start">
        {/* Table Section */}
        <section
          className="w-2/3 bg-white rounded-md flex flex-col"
          aria-label="Details Table"
        >
          <Table>
            <DataTableHeader table={table} />
            <DataTableBody table={table} isLoading={isLoading} />
          </Table>

          <DataTablePagination
            table={table}
            entityLabel="pagination_entity_control_results"
            isLoading={isLoading}
          />
        </section>

        {/* Sidebar Section */}
        <aside className="flex w-1/3 flex-col gap-4">
          {/* Activity Section */}
          <section
            className="bg-white rounded-md p-4 items-center gap-4"
            aria-label="Activity"
          >
            <ResultDetailActivityTabs
              controlId={controlId}
              companyId={companyId}
              controlResultId={controlResultId}
            />
          </section>
        </aside>
      </div>
    </div>
  );
};
